import api from '../../apiConfig/apiConfig';
import { Post, Get } from '../base/baseAjax';

// SEO收录信息
let getSeoInfo = params => {
	return Get({
		url: api.seoTakeDown.getSeoInfo,
		UrlParam: params,
	});
};

// 重新生成报告
let seoUpset = params => {
	return Post({
		url: api.seoTakeDown.seoUpset,
		UrlParam: params,
	});
};

export default {
	getSeoInfo,
	seoUpset,
};
